export const menus = [
    {
        title: "Home",
    },
    {
        title: "About Us",
        children: [
            { title: "Lab Family Culture" },
            { title: "People" },
            { title: "Robots" },
            { title: "Awards" },
            { title: "Fun" },
        ],
    },
    {
        title: "Research",
        children: [
            { title: "Areas" },
            { title: "Domains" },
            { title: "Projects" },
            { title: "Resources" },
            { title: "Publications" },
            { title: "Sponsors" },
        ],
    },
    {
        title: "Outreach",
    },
    {
        title: "Media",
        children: [{ title: "Media Coverage" }, { title: "Videos" }],
    },
    {
        title: "Contact",
    },
]

